import { createAction } from '@reduxjs/toolkit';
import { addNamespace } from '@Utils/actions';
import {
	CreateFailureDefinitionRequest,
	FailureDefinition,
	FailureDefinitionRunResult,
	GetFailureDefinitionRunResultsRequest,
} from '@Types';
import { Status, Pagination } from '@innovyze/lib-am-common';

export const upsertFailureDefinition = createAction<{
	request: CreateFailureDefinitionRequest & { failure_definition_id?: string };
	onSuccess?: (id: string) => void;
	onError?: (message: string) => void;
}>(addNamespace('failureDefinition/upsert'));

export const upsertFailureDefinitionResolved = createAction<{ id: string }>(
	addNamespace('failureDefinition/upsertResolved'),
);

export const upsertFailureDefinitionRejected = createAction(addNamespace('failureDefinition/upsertRejected'));

export const clearFailureDefinitionCreationState = createAction(addNamespace('failureDefinition/clearCreationState'));

export const runFailureDefinition = createAction<{ id: string }>(addNamespace('failureDefinition/run'));

export const runFailureDefinitionResolved = createAction<{ id: string }>(addNamespace('failureDefinition/runResolved'));

export const runFailureDefinitionRejected = createAction<Status>(addNamespace('failureDefinition/runRejected'));

export const listAllFailureDefinitions = createAction(addNamespace('failureDefinition/listAll'));

export const listAllFailureDefinitionsResolved = createAction<FailureDefinition[]>(
	addNamespace('failureDefinition/listAllResolved'),
);

export const listAllFailureDefinitionsRejected = createAction<Status>(
	addNamespace('failureDefinition/listAllRejected'),
);

export const getFailureDefinitionAction = createAction<string>(addNamespace('failureDefinition/get'));

export const getFailureDefinitionResolved = createAction<FailureDefinition>(
	addNamespace('failureDefinition/getResolved'),
);

export const getFailureDefinitionRejected = createAction<Status>(addNamespace('failureDefinition/getRejected'));

export const copyFailureDefinition = createAction<{
	id: string;
	onSuccess?: (id: string) => void;
	onError?: () => void;
}>(addNamespace('failureDefinition/copy'));

export const copyFailureDefinitionResolved = createAction<{ id: string }>(
	addNamespace('failureDefinition/copyResolved'),
);

export const copyFailureDefinitionRejected = createAction<Status>(addNamespace('failureDefinition/copyRejected'));

export const deleteFailureDefinition = createAction<{ id: string }>(addNamespace('failureDefinition/delete'));

export const deleteFailureDefinitionResolved = createAction<{ id: string }>(
	addNamespace('failureDefinition/deleteResolved'),
);

export const deleteFailureDefinitionRejected = createAction<Status>(addNamespace('failureDefinition/deleteRejected'));

export const getFailureDefinitionRunResults = createAction<GetFailureDefinitionRunResultsRequest>(
	addNamespace('failureDefinition/getRunResults'),
);

export const getFailureDefinitionRunResultsResolved = createAction<{
	pagination: Pagination;
	data: FailureDefinitionRunResult[];
}>(addNamespace('failureDefinition/getRunResultsResolved'));

export const getFailureDefinitionRunResultsRejected = createAction<Status>(
	addNamespace('failureDefinition/getRunResultsRejected'),
);

export const setFailureDefinitionPaginationState = createAction<{
	failureDefinitionId: string;
	paginationRequest: GetFailureDefinitionRunResultsRequest;
}>(addNamespace('failureDefinition/setPaginationState'));

export const clearFailureDefinitionPaginationState = createAction<{
	failureDefinitionId: string;
}>(addNamespace('failureDefinition/clearPaginationState'));

export const updateFailureDefinitionPublishedStatus = createAction<{
	failureDefinition: FailureDefinition;
	published: boolean;
}>(addNamespace('failureDefinition/updatePublishedStatus'));

export const updateFailureDefinitionPublishedStatusResolved = createAction<{
	id: string;
	published: boolean;
}>(addNamespace('failureDefinition/updatePublishedStatusResolved'));

export const updateFailureDefinitionPublishedStatusRejected = createAction<Status>(
	addNamespace('failureDefinition/updatePublishedStatusRejected'),
);
export const renameFailureDefinition = createAction<{
	id: string;
	newName: string;
	currentDefinition: CreateFailureDefinitionRequest;
	onSuccess?: () => void;
	onError?: (message: string) => void;
}>(addNamespace('failureDefinition/rename'));

export const renameFailureDefinitionResolved = createAction<{ id: string; name: string }>(
	addNamespace('failureDefinition/renameResolved'),
);

export const renameFailureDefinitionRejected = createAction<Status>(addNamespace('failureDefinition/renameRejected'));
